import React from "react";

// Eye icon — the same "view" mark as the blue View button, but drawn as inline
// SVG rather than the 👁 emoji so it renders as a SOLID single colour. Emoji
// are fixed-colour glyphs that ignore `color` (the same reason the reject ⛔
// needs a grayscale filter to mute it), so a white eye on a coloured button
// can't be done with the character. Inherits button text colour.
export const EyeIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    style={{ display: "block" }}
  >
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
  </svg>
);
